import React, { useEffect, useState } from 'react'
import QRCode from 'qrcode'

type PageQrCardProps = {
    url: string
    title?: string
    subtitle?: string
}

const PageQrCard: React.FC<PageQrCardProps> = ({
    url,
    title = 'Escanea y abre la página',
    subtitle = 'Útil para compartirla o probarla rápido desde tu celular',
}) => {
    const [qrCodeUrl, setQrCodeUrl] = useState<string>('')

    useEffect(() => {
        let isMounted = true

        const generateQrCode = async (): Promise<void> => {
            try {
                const dataUrl = await QRCode.toDataURL(url, {
                    width: 320,
                    margin: 1,
                    errorCorrectionLevel: 'M',
                    color: {
                        dark: '#0f172a',
                        light: '#ffffff',
                    },
                })

                if (isMounted) {
                    setQrCodeUrl(dataUrl)
                }
            } catch (error) {
                console.error('Error generating QR code', error)
            }
        }

        void generateQrCode()

        return () => {
            isMounted = false
        }
    }, [url])

    return (
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-soft sm:p-6">
            <div className="mb-4 flex items-start justify-between gap-4">
                <div>
                    <h3 className="text-lg font-semibold text-gray-900 sm:text-xl">{title}</h3>
                    <p className="mt-1 text-sm text-gray-600 sm:text-base">{subtitle}</p>
                </div>
                <span className="rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary-700">
                    QR
                </span>
            </div>

            <div className="flex flex-col items-center gap-4 rounded-2xl bg-slate-50 p-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex h-40 w-40 items-center justify-center rounded-2xl bg-white p-3 shadow-sm sm:h-44 sm:w-44">
                    {qrCodeUrl ? (
                        <img
                            src={qrCodeUrl}
                            alt={`Código QR para ${url}`}
                            className="h-full w-full rounded-xl object-contain"
                            loading="lazy"
                        />
                    ) : (
                        <div className="h-full w-full animate-pulse rounded-xl bg-slate-100" />
                    )}
                </div>

                <div className="min-w-0 flex-1 text-center sm:text-left">
                    <p className="text-sm font-semibold text-gray-900">URL objetivo</p>
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-1 block break-all text-sm text-primary-700 underline-offset-4 hover:underline"
                    >
                        {url}
                    </a>
                    <p className="mt-3 text-sm text-gray-500">
                        Recomendado para material impreso, recepción o publicaciones en redes.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PageQrCard